import pluralize from 'pluralize'

import { Banner } from '@/components/ui/banner'
import { Button } from '@/components/ui/button'
import { blockingChecks, type FillCheck } from '@/models/fillApplication'
import { useFillJump } from '../App/Customers/FillApplication/FillJumpProvider'

export const ALMOST_READY =
  'Your application is almost ready to submit! Provide the missing information, and get your insurance quotes today.'
export const READY =
  'Your application is ready to submit! Please review all answers for accuracy and completeness, and get your quotes today!'

/** At the top: where the application stands, and while answers are missing, how many and a way to the first. */
export function MissingSummary({ checks }: { checks: FillCheck[] }) {
  const { jump } = useFillJump()
  const blocking = blockingChecks(checks)
  // A roster line can stand for several answers, e.g. "missing info to 3 more drivers".
  const answers = blocking.reduce((total, check) => total + (check.answers ?? 1), 0)

  return (
    <div className="flex flex-col gap-4">
      <p className="text-md text-ink-500 leading-relaxed">{blocking.length > 0 ? ALMOST_READY : READY}</p>
      {blocking.length > 0 && (
        <Banner
          variant="warning"
          small
          align="center"
          inlineAction
          action={
            <Button type="button" variant="outline" size="sm" onClick={() => jump(blocking[0])}>
              Show me
            </Button>
          }
        >
          {pluralize('answer', answers, true)} missing
        </Banner>
      )}
    </div>
  )
}
